<footer>
    <div class="content-wrapper">
        <div class="float-left">
            <app-version></app-version>
            <p>&copy; {{ copyright }}</p>
        </div>
    </div>
</footer>